import axios from 'Axios';
import { GET_CURRENT_USER } from '../api/Routes';

function getUserStart() {
  return {
    type: 'GET_USER_START',
  };
}

function getUserDone(data) {
  return {
    type: 'GET_USER_DONE',
    user: data,
  };
}
function userError(errorMessage) {
  return {
    type: 'USER_ERROR',
    errorMessage,
  };
}
export const getCurentUser = () => {
  return function(dispatch) {
    dispatch(getUserStart());
    axios
      .get(GET_CURRENT_USER)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(getUserDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(userError(errorMessage));
      });
  };
};
